import { IUserAuthorizationState } from '../../../types/index'
import { saveAuthTokens, setRefreshAuthTokenSender, LOCAL_STORAGE_USER_TYPE } from '../../../utils/auth'
import { IAuthActions } from '../../actions/auth/index'
import * as constants from '../../constants'
import { RecoveryTokenStatuses } from '../../../constants/authentication'

const initialAuthState: IUserAuthorizationState = {
  isLogged: false,
  recoverPasswordTokenStatus: RecoveryTokenStatuses.IS_NOT_CHECKED,
  isFetching: false,
  error: null,
  isFetchSuccess: false,
  type: localStorage.getItem(LOCAL_STORAGE_USER_TYPE) || ''
}

export function authorization(
  state: IUserAuthorizationState = initialAuthState,
  action: IAuthActions
): IUserAuthorizationState {
  switch (action.type) {
    case constants.CLEAR_AUTH_STATE:
      return initialAuthState
    case constants.AUTHORIZATION_REQUEST:
      return Object.assign({}, state, {
        isFetching: true
      })
    case constants.AUTHORIZATION_SUCCESS: {
      const authTokens = action.payload
      saveAuthTokens(authTokens, action.payload.type)
      setRefreshAuthTokenSender(authTokens.accessToken)
      return Object.assign({}, state, {
        error: null,
        isLogged: true,
        isFetching: false,
        type: action.payload.type || state.type
      })
    }
    case constants.AUTHORIZATION_FAIL:
      return Object.assign({}, state, {
        isFetching: false,
        error: action.payload
      })
    case constants.RECOVER_PASSWORD_REQUEST:
      return Object.assign({}, state, {
        isFetching: true
      })
    case constants.RECOVER_PASSWORD_SUCCESS:
      return Object.assign({}, state, {
        isFetching: false,
        isFetchSuccess: true
      })
    case constants.RECOVER_PASSWORD_FAIL:
      return Object.assign({}, state, {
        error: action.payload,
        isFetching: false,
        isFetchSuccess: false
      })
    case constants.RESET_FETCH_SUCCESS:
      return Object.assign({}, state, {
        isFetchSuccess: false
      })
    case constants.CHANGE_PASSWORD_REQUEST:
      return Object.assign({}, state, {
        isFetching: true
      })
    case constants.CHANGE_PASSWORD_SUCCESS:
      return Object.assign({}, state, {
        isFetching: false,
        isFetchSuccess: true,
        recoverPasswordTokenStatus: RecoveryTokenStatuses.IS_NOT_CHECKED
      })
    case constants.CHANGE_PASSWORD_FAIL:
      return Object.assign({}, state, {
        error: true,
        isFetching: false
      })

    case constants.CHECK_TOKEN_REQUEST:
      return Object.assign({}, state, {
        isFetching: true
      })
    case constants.CHECK_TOKEN_SUCCESS:
      return Object.assign({}, state, {
        isFetching: false,
        recoverPasswordTokenStatus: RecoveryTokenStatuses.IS_VALID
      })
    case constants.CHECK_TOKEN_FAIL:
      return Object.assign({}, state, {
        isFetching: false,
        recoverPasswordTokenStatus: RecoveryTokenStatuses.IS_NOT_VALID,
        error: action.payload
      })

    case constants.REGISTER_USER_REQUEST:
      return Object.assign({}, state, {
        error: null,
        isFetchSuccess: false,
        isFetching: true
      })
    case constants.REGISTER_USER_SUCCESS:
      return Object.assign({}, state, {
        isFetching: false,
        isFetchSuccess: true
      })
    case constants.REGISTER_USER_FAIL:
      return Object.assign({}, state, {
        isFetching: false,
        isFetchSuccess: false,
        error: action.payload
      })

    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/state/reducers/auth/index.ts